
export default function LoadingSpinner(){
    return(
        <div className="flex justify-center items-center w-full h-full">
            <style>
                {`
                @keyframes loader-rotate {
                0% {
                    transform: rotate(0);
                }
                100% {
                    transform: rotate(360deg);
                }
                }
                .loader {
                border-right-color: transparent;
                animation: loader-rotate 0.8s linear infinite;
                }
                `}
            </style>
            <div class="w-5 h-5 border-2 border-gray-300 rounded-full loader"></div>
        </div>
    )
}